import * as THREE from 'three'
import { useRef, useState, useEffect,useLocalStorage,useSessionStorage } from 'react'
import { useParams,useNavigate, Link } from 'react-router-dom'
import { Canvas, useFrame } from '@react-three/fiber'
import { CameraControls, Html , Stats, Sky, Stars} from '@react-three/drei'
import { isMobile } from 'react-device-detect';
import { useThree } from "@react-three/fiber"
import PageVisibility from 'react-page-visibility';
import useEventListener from '@use-it/event-listener'
import Drawer from '@mui/material/Drawer';
import { useInterval } from 'usehooks-ts'

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';


import Header from './HeaderMob';

//import { Perf } from 'r3f-perf'
//import data from './data.json'

import {
    TwitterShareButton,
    LinkedinShareButton,
    RedditShareButton,
    WhatsappShareButton,
} from "react-share";
import { useTimeout } from 'react-admin'



const requestEndpoint = process.env.REACT_APP_REQUEST_END_POINT
//const paymentGateway = process.env.REACT_APP_PAYMENTGATEWAYNEW
//const LockEndPoint = process.env.REACT_APP_LOCK_END_POINT

var speed = 0.1;
var boxes = [];
var next = 10;
var nextZ = 10;
var nextX = 10;


var fetchThat;

var randomPosX = (min = -60, max = 60) => Math.random() * (max - min) + min
var randomPosY = (min = -100, max = 100) => Math.random() * (max - min) + min
var randomPosZ = (min = -60, max = 60) => Math.random() * (max - min) + min
var randomPosNew = (min = 0, max = 10) => Math.random() * (max - min) + min


const getcss = (css, mobile) => {
    if (isMobile) {
        css = css + " " + mobile;
    }
    return css;
}



const TextMe3d = (props) => {


    function turnToPhrase(str) {
        var a = "";
        try {
            a = str.replace(/_/g, " ").replace(/\|/g, " ");
        } catch (e) {
            a = str;
        }
        return a;
    }
    var divId = "clickme_" + props.Strawberry;

    return (
        <Html {...props}
            name={divId}
            transform
            position={[props.position[0], props.position[1], props.position[2]]}
            style={{
                pointerEvents: "none",
                color: props.value === "-1" ? "#B200ED" : props.owner === props.userInfo ? "green" :  "blue",
                fontSize: "14px",
                width: "200px",
                fontFamily: 'NewFont'
            }}
        >
            <div  onClick={(e) => { props.handleClick(props.shape.current.position) }}>
                {turnToPhrase(props.text)}<br /><br />
                {props.author != "" ? props.author : "Anonymous"}
            </div>
        </Html>
    )

}


const CustomBox = (props) => {

    const navigate = useNavigate();

    const shape = useRef();
    const [hidden, setHidden] = useState(true);
    const [isMove, setIsMove] = useState(props.move)
    const [info, SetInfo] = useState(false)
    const [feedback, setFeedback] = useState("");
    const [open, setOpen] = useState(false);
    const [buyId, setbBuyId] = useState(10);
    
    useEffect(() => {
        setIsMove(props.move)
    }, [props.move])

    const handleClick = (position) => {
        var pos = new THREE.Vector3();
        var look = new THREE.Vector3();

        if (isMove) {
            next = position.z;
            var sum = -4;
            pos.set(position.x, position.y, position.z + sum);
            look.set(position.x, position.y, position.z);
            props.cameraControlRef.current?.moveTo(pos.x, pos.y, pos.z, true);
            props.setTarget(pos);
            setHidden(false);
            props.setMove(false);
            props.setFooter(true);
            navigate('/' + props.Strawberry, { replace: true })
        }
        props.setActionsBack(true);
        props.setHello(false);
    }
 
    useEffect(() => {
        if (!props.actionsBack) {
            clearTimeout(fetchThat);
            props.setMove(true);
            props.setTarget();
            setHidden(true);
            props.setFooter(false);
        }

    }, [props.actionsBack])
    
    

    async function buy(id) {  
        navigate("/buy/" + id);    
    }

    
    const openInSameTab = url => {
        window.open(url, '_self', 'noopener,noreferrer');
    };


    function clickNew() {
            openInSameTab(process.env.PUBLIC_URL + "/new");  
    }

    function logout() { 
        props.setUserInfo();
        sessionStorage.removeItem("userinfo");
        sessionStorage.removeItem("wallet");
    }

    function clicMoreInfo() { 
        var cv = document.getElementById('canvasDiv');
        var more = document.getElementById('MoreInfo');
    
        //var cv = document.getElementById('flyDiv'); 
        cv.hidden = true;
        more.hidden = false;

        //SetWant2buy(false);
        //navigate('/about');
    }

    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var created = new Date(Date.parse(props.createdAt));
    var createdString = months[created.getMonth()] + " " + created.getDate() + ", " + created.getFullYear();

    var value = (props.value / 100) * 2;

    var url = process.env.REACT_APP_PUBLIC_URL + "/" + props.id;

    const toggleDrawer = (newOpen,id) => () => {
        setbBuyId(id);
        setOpen(newOpen);

    };



    const DrawerList = (customProps) => (
        <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
            <Divider > Idea </Divider >
            <List >
                {props.ForSale === 1 ?
                    <ListItem key="BUY THIS IDEA" disablePadding > 
                        <ListItemText primary="Buy" onClick={() =>
                            buy(props.Strawberry)}
                            className='pl-5' />
                    </ListItem>
                    :
                    <ListItem key="Not For Sale" disablePadding >
                        <ListItemText primary="Not For Sale"
                            className='pl-5' />
                    </ListItem>
                }

                <ListItem key="CREATE AN IDEA" disablePadding>
                    <ListItemText primary="New"
                        className='pl-5'     />
              </ListItem>


          </List>
            <Divider > Account </Divider >
            <List dense={true} >
            {!sessionStorage.getItem("userinfo") || sessionStorage.getItem("userinfo")?.length < 50 ?
            <>
            <ListItem key="LOGIN" disablePadding>
                <ListItemText primary="LOGIN" className='pl-5' onClick={() => navigate("/login") } />
            </ListItem>
            <ListItem key="REGISTER" disablePadding >
                <ListItemText primary="REGISTER" className='pl-5'  onClick={() => navigate("/register") } />
            </ListItem>
            </>
                    :
                    <ListItem key="LOGOUT" disablePadding >
                        <ListItemText primary="LOGOUT" className='pl-5' onClick={() => {logout()}}/>
                </ListItem>
            }


            </List>
            <Divider > Share </Divider >
            <List dense={true}>
            <ListItem key="X" disablePadding>
            <TwitterShareButton url={url} ><div className='pl-5 text-sm font-thin'>[X]</div></TwitterShareButton>
            </ListItem>
            <ListItem key="LINKEDIN" disablePadding>
            <LinkedinShareButton url={url} ><div className='pl-5 text-sm font-thin'>[Linkedin]</div></LinkedinShareButton>

            </ListItem>
            <ListItem key="WHATSAPP" disablePadding>
            <WhatsappShareButton url={url} ><div className='pl-5 text-sm font-thin'>[WhatsApp]</div></WhatsappShareButton>
            </ListItem>



            </List>
            <div className="absolute bottom-0 w-full flex justify-end pr-5" onClick={toggleDrawer(false)}> close </div >
        </Box>
    );
    
    
    return (

        <group>
            <mesh
                ref={shape}
                position={[props.position[0] , props.position[1], props.position[2]]}
            // onClick={(e) => { handleClick(e) }}
            >
                <boxGeometry args={[5, 5, 0.5]} />
                <meshBasicMaterial visible={false}
                    color={'#90EE90'}
            
                    wireframe
                />
            </mesh>
            <TextMe3d
                position={[props.position[0], props.position[1], props.position[2]]}
                text={props.idea}
                author={props.author}
                Strawberry={props.Strawberry}
                shape={shape}
                handleClick={handleClick}
                owner={props.owner}
                userInfo={props.userInfo?.id}
                />
            
            { /* 
            <KeyboardObject  {...props} transparent={true}> </KeyboardObject>
           */}
            <Html
                position={[props.position[0], props.position[1], props.position[2]]}
                style={{
                    transition: 'all 0.05s',
                    opacity: hidden ? 0 : 1,
                    transform: `scale(${hidden ? 0 : 1})`,
                    userSelect: 'none'
                  
                
                }} fullscreen
            >
                <div className="overlayM"></div>
                <div className={"actionsM"}  onClick={toggleDrawer(true,props.Strawberry)} >
                    [ ACTIONS ]
                </div>
                <Drawer open={open} >
                    {DrawerList({vasco:props.Strawberry.id})}
                </Drawer>
              
            </Html>

        </group >
    )
}
const FetchData = ({ setData, setHello, my, userInfo, filteredMessageid }) => {
  
  const getIdeas = async () => {
    try {
      //vasco

      var options = {
        headers: {
          token: my && userInfo?.token ? userInfo.token : '',
          target: filteredMessageid || '',
        },
      };

      const response = await fetch(requestEndpoint, options);

      //const data = (await response.json()).slice(0, 100);
      const data = (await response.json()).slice(0, 100);

        
      var newJson;

      newJson = data.map((obj) => {
        return {
          ...obj,
          x: randomPosX(-20, 20),
          y: randomPosY(-20, 20),
          z: randomPosZ(0, 30),
          color: new THREE.Color("rgb(255,0,0)")
        };
      });

      sessionStorage.setItem("data", JSON.stringify(newJson));
      //console.log(newJson);

      setData(newJson);
    } catch (error) {
      console.error(error);
    }
  };

    useEffect(() => {
    try {
      var d = JSON.parse(sessionStorage.getItem("data"));
      if (d == null) {
        getIdeas();
        setTimeout(() => {
          setHello(true);
        }, 7000);
      } else {
        getIdeas();
      }
    } catch (error) {

    }
  }, [my]);

  return null;
};



const BoxCreator = ({ data, cameraControlRef, move, setMove, setTarget,finder_id,setFooter,setHello,setAbout,userInfo,setUserInfo,setActionsBack,actionsBack }) => {
    const [lastZ, setLastZ] = useState(0);
    const [localData, setLocalData] = useState([]);
    const prevDataLengthRef = useRef(0);

    // Reset when data changes (switching between My/All)
    useEffect(() => {
        if (data.length !== prevDataLengthRef.current) {
            prevDataLengthRef.current = data.length;
            const newData = data.map((obj, i) => ({
                ...obj,
                z: i * randomPosZ() * -0.5
            }));
            setLocalData(newData);
            setLastZ(newData.length > 0 ? newData[newData.length - 1].z : 0);
        }
    }, [data]);

    if (lastZ === 0 && data.length > 0 && localData.length === 0) {
        // Create a deep copy to avoid mutating the original data
        const newData = data.map((obj, i) => ({
            ...obj,
            z: i * randomPosZ() * -0.5
        }));
        setLocalData(newData);
        setLastZ(newData[newData.length - 1].z);
    }

    const workingData = localData.length > 0 ? localData : data;
    boxes = [];

    for (let i = 0; i < workingData.length; i++) {
        var name = "cube" + i;
        boxes.push({
            name: name,
            object: workingData[i],
            Thiskey: i,
        })
    }


    var newZ;
    useFrame((state) => {

        newZ = lastZ;

        var index = -1;

        for (var i = 0; i < workingData.length; i++) {
            if (workingData[i].z > state.camera.position.z) {
                newZ = lastZ - randomPosNew();
                setLastZ(newZ);
                index = i;
            }
        }


        if (index > -1) {
            workingData[index].z = newZ;
        }

    });

    return (
        <>
            {
                boxes.map((box, index) => (
                    <CustomBox
                        Strawberry={box.object.id}
                        name={box.name}
                        Thiskey={box.Thiskey}
                        key={index}
                        position={[box.object.x, box.object.y, box.object.z]}
                        material-color={box.object.color}
                        idea={box.object.phrase}
                        author={box.object.author}
                        wallet={box.object.wallet}
                        username={box.object.username}
                        owner={box.object.user.id}
                        createdAt={box.object.createdAt}
                        value={box.object.value}
                        ForSale={box.object.ForSale}
                        cameraControlRef={cameraControlRef}
                        move={move}
                        setMove={setMove}
                        setTarget={setTarget}
                        finder_id={finder_id}
                        setFooter={setFooter}
                        setHello={setHello}
                        setAbout={setAbout}
                        setUserInfo={setUserInfo}
                        userInfo={userInfo}
                        setActionsBack={setActionsBack}
                        actionsBack={actionsBack}
                       
                    />
                ))
            }
        </>
    )
}


const BoxManager = (props) => {
    const {
        data,
        setData,
        cameraControlRef,
        move,
        setMove,
        setTarget,
        filter,
        finder_id,
        setFooter,
        setHello,
        setAbout,
        userInfo,
        setUserInfo,
        my,
        setActionsBack,
        actionsBack,
    } = props;


    var filters = [
        o => o.phrase.toUpperCase().indexOf(filter.toUpperCase()) > -1,
    ];
    var data_filtered = data.filter(o => filters.some(fn => fn(o)));
    



    return (
        <>
            {data.length === 0 ?
                <FetchData
                    setData={setData}
                    setHello={setHello}
                    data={data}
                    my={my}
                    userInfo={userInfo}
                    filteredMessageid={finder_id}
                />
                :
                <BoxCreator //todo testing
                    data={data_filtered}
                    cameraControlRef={cameraControlRef}
                    move={move}
                    setMove={setMove}
                    setTarget={setTarget}
                    finder_id={finder_id}
                    setFooter={setFooter}
                    setHello={setHello}
                    setAbout={setAbout}
                    userInfo={userInfo}
                    setUserInfo={setUserInfo}
                    setActionsBack={setActionsBack}
                    actionsBack={actionsBack}
                />
            }

        </>
    );

}

const CameraGo = ({ cameraControlRef, move, target, ManualDrive ,throttle,joyMove}) => {

    useEffect(() => {
        if (cameraControlRef.current) {

            cameraControlRef.current.maxPolarAngle = Math.PI / 2 + 0.17;
            cameraControlRef.current.minPolarAngle = Math.PI / 2 - 0.17;
            cameraControlRef.current.maxAzimuthAngle = 0 + 0.17;
            cameraControlRef.current.minAzimuthAngle = 0 - 0.17;

            cameraControlRef.current.noPan = true;
            cameraControlRef.current.maxDistance = cameraControlRef.current.minDistance = cameraControlRef.current.distance;
            cameraControlRef.current.noKeys = true;
            cameraControlRef.current.noRotate = true;
            cameraControlRef.current.noZoom = true;
        }
    }, [cameraControlRef])

    useFrame((state, delta) => {
        
        if (move) {
            if (!ManualDrive) {
                cameraControlRef.current?.moveTo(0, 0, next, true);
                next -= speed;
            } else { 
                cameraControlRef.current?.moveTo(nextX, nextZ, next, true);
                next -= throttle.y;
                
               
                nextX -= joyMove.x/10*-1;
                nextZ -= joyMove.y/10*-1;
                
                if (nextX < -150) nextX = -149;
                if (nextX > 150) nextX = 149;
                
                if (nextZ < -120) nextZ = -119;
                if (nextZ > 120) nextZ = 119;
                

                
            }
        } else {
            if (target) {
                cameraControlRef.current?.moveTo(target.x, target.y, target.z, true);
            }
        }

        
    })


    

 


    return (
        <CameraControls ref={cameraControlRef} />
    );
}

const openInSameTab = url => {
    window.open(url, '_self', 'noopener,noreferrer');
};


function clickNew(whereTo) { 
    openInSameTab(process.env.PUBLIC_URL + whereTo );
}


const Body = (props) => {

    const navigate = useNavigate();
    const cameraControlRef = useRef([CameraControls]);
    const [data, setData] = useState([]);
    const [move, setMove] = useState(true)
    const [target, setTarget] = useState();
    const [filter, setFilter] = useState("");
    const [footer, setFooter] = useState(false);
    const [SStats, seStats] = useState(false);
    const [inclination, setInc] = useState(1.0);
    const [azimuth, setAzimuth] = useState(0);
    const [hello, setHello] = useState(false);
    const [about, setAbout] = useState(false);
    const [ManualDrive, setManualDrive] = useState(false);
    const [my, setMy] = useState(false);
    const hasPageBeenRendered = useRef(false);
    const [throttle, handleT] = useState({ x: 0, y: 0 })
    const [joyMove, handleM] = useState({ x: 0, y: 0 })
    const isNavigating = useRef(false);
    const prevActionsBack = useRef(false);

    const [actionsBack, setActionsBack] = useState(false)

    //vasco comment 1

  useEffect(() => {
    hasPageBeenRendered.current = true;
  }, []);

  // Handle navigation when going back to galaxy (only when actionsBack goes true → false)
  useEffect(() => {
    if (!actionsBack && prevActionsBack.current && !isNavigating.current) {
      isNavigating.current = true;
      const currentPath = window.location.pathname;
      if (currentPath !== '/') {
        window.history.replaceState(null, '', '/');
        window.dispatchEvent(new PopStateEvent('popstate', { state: null }));
      }
      setTimeout(() => {
        isNavigating.current = false;
      }, 100);
    }
    prevActionsBack.current = actionsBack;
  }, [actionsBack]);

  // Refetch data when 'my' filter changes
  useEffect(() => {
    const refetchData = async () => {
      try {
        // Clear old sessionStorage data to prevent position issues
        sessionStorage.removeItem("data");

        var options = {};
        if (my) {
          options = {
            headers: { token: userInfo.token }
          };
        }

        const response = await fetch(requestEndpoint, options);
        const data = (await response.json()).slice(0, 100);
          console.log(data.length);

          //return;

        var newJson = data.map((obj) => {
          return {
            ...obj,
            x: randomPosX(-20, 20),
            y: randomPosY(-20, 20),
            z: randomPosZ(0, 30),
            color: new THREE.Color("rgb(255,0,0)")
          };
        });

        sessionStorage.setItem("data", JSON.stringify(newJson));
        setData(newJson);
      } catch (error) {
        console.error("Error refetching data:", error);
      }
    };

    // Only refetch if page has been rendered and we have data (not initial load)
    if (hasPageBeenRendered.current && data.length > 0) {
      refetchData();
    }
  }, [my]);


 


    var userdata = "";

    if(JSON.parse(sessionStorage.getItem("userinfo"))) {
      
        userdata = JSON.parse(sessionStorage.getItem("userinfo"));
    } else { 
        userdata = "{id:0 , token:''}";
    }
    const [userInfo, setUserInfo] = useState({ id: userdata.id ? userdata.id : 0, token: userdata.token ? userdata.token : "" });
    
 
    const { FilteredMessageid } = useParams()
    
    /** 1/2 by word */
    function beRightBack(str) { 
        const wordCount = str.split('_').length;
    setTimeout(() => {
        setActionsBack(false);
    }, wordCount * 500);
}

    function Counter() {
        const [count, setCount] = useState(0);
        var d = JSON.parse(sessionStorage.getItem("data"));
        
          
            const randomElement = d[Math.floor(Math.random() * d.length)]; 
            const { scene } = useThree();
            
            useInterval(() => {
                setCount(count + 1);
                const randomElement = d[Math.floor(Math.random() * d.length)]; 
                var name = "clickme_" + randomElement.id;
                var target = scene.getObjectByName(name);
                target.handleClick(target.position);    
                beRightBack(randomElement.phrase);
            }, 5000);
       
    }
    
    function FindPositionFromId({id}) { 
        const { scene } = useThree();
        if (id != null) {   
            fetchThat = setTimeout(function () {
                var name = "clickme_" + id;
                var target = scene.getObjectByName(name);
                target.handleClick(target.position);      
            }, 2000);
        }
    }

    
  
    

    const handlerD = (event) => { 
        if (event.key === "ArrowDown") {
            if (inclination > 0) setInc(inclination - 0.01);
        }
        if (event.key === "ArrowUp") {
            if (inclination < 1) setInc(inclination + 0.01);
        } 
        if (event.key === "ArrowLeft") {
            if (azimuth > 0) setAzimuth(azimuth -0.1);
        }
        if (event.key === "ArrowRight") {
            if (azimuth < 1) setAzimuth(azimuth + 0.1);
        }
    }
  
 
   
    const handlerU = (event) => { 
        if (event.key === "s") {
            seStats(!SStats);
        }
    }
    useEventListener('keydown', handlerD);
    useEventListener('keyup', handlerU);
    
    function Messages() {
        const [hide, setHide] = useState(false);
    
        if (hello && !FilteredMessageid) { 
            setTimeout(() => {
                setHide(true);    
                    setTimeout(() => {
                        setHello(false);
                    }, 4500);
            }, 2000);
        }
        return (
             <div className={hide ? 'fadeOut' : 'full'} >
                <div > Please click on an Idea </div>
            </div>
        )
    
        
    }
    


    
        
    function closeMoreInfo() { 
        var cv = document.getElementById('canvasDiv');
        var more = document.getElementById('MoreInfo');
        
        cv.hidden = false;
        more.hidden = true;
    }



    return (
        <div className='MainW'>
            
            { 
            //<GalaxyFooter setFilter={setFilter} hide={!footer}/>                    
            } 
            
            
            <Header bg={true} destination="/about" />
            {
                userInfo?.id ?
                        <div className='absolute top-10 left-0 w-full flex flex-row justify-center text-2xl'  >
                            <div className={my ? "underline text-blue-700 z-50 pr-3" :  " z-50 pr-3 "  } onClick={() => setMy(true)} >My</div>
                            <div>/</div>
                            <div className={my ?  " z-50 pr-3 " : "underline text-blue-700 z-50 pr-3"   } onClick={() => setMy(false)} >All</div>
                        </div>
                       
                
                :
                null
            }
         
            {hello ? 
                <Messages />
                :
                null
            }
            <div className='MoreInfo' hidden id="MoreInfo">
            
                <div className="body_class">
                <div className={  !isMobile ? 'mouse2 moreinfo' : 'mouse2 moreinfoMob'} onClick={() => closeMoreInfo()} >[ BACK ]</div>
                    < div className="readMoreb" >
                            Ideas & Thoughts & Feelings & Visions < br />
                            Questions & Beliefs & Clues & Schemes < br />
                            Hypothesis & Purposes & Plans < br />
                            Statements & Words & Messages & Prompts < br /> <br />
                            They all live now and forever on Hyperuranium.< br />
                            
                            When tokenized, others start taking care of them.< br /> <br />
                            this is the first autonomous version of our platform, which is forked from CENSORED.ART (https://censored.art).<br /><br />
                            <div className='w-full flex items-stretch flex-row border-red-600 justify-evenly'>
                            <div className='flex py-4  border-blue-500 items-start flex-col'>
                                <div className="mouse2" onClick={() => window.open("/new","_self")}>Mint Idea</div>
                                {!isMobile ?      
                                    <div className="mouse2" onClick={() => window.open("/listing", "_self")}>
                                        Listing</div>
                                :
                                null
                                }
                            </div>
                            <div className='flex py-4 border-blue-500 flex-col' >
                                {sessionStorage.getItem('userinfo') === null ? 
                                    <div className="mouse2" onClick={() => window.open("/login", "_self")}>
                                        login
                                    </div>
                                :
                                    <div className="mouse2" onClick={() => { sessionStorage.removeItem('userinfo'); window.location.reload();}}>
                                    logout
                                </div>
                                }
                                <div className="mouse2" onClick={() => window.open("/register", "_self")}>Register</div>
                                    <div className="mouse2" onClick={() => window.open("/profile", "_self")}>Profile</div>

                                
                            </div>
                        </div>

                    </div >
                                
                </div >
                

            </div>
          
            {actionsBack ?
                <div className='z-[100] absolute bottom-5 left-0 w-full flex flex-col justify-center text-2xl'>
                 

                    <div className={"z-[1000] mouse2  border-red-500 w-full flex justify-center"} onClick={() => setActionsBack(false)}  >
                        [ BACK TO GALAXY ]
                    </div>
                </div>
                :
                null
            }
                
            <div className='canvasDiv' id='canvasDiv'>
               
            <Canvas
                width="520" height="520"
                linear
                camera={{ position: [0, 5, 15], fov: 60 }}
                frameloop="demand"
                    gl={{ powerPreference: 'high-performance', antialias: false }}>
                     <FindPositionFromId id={FilteredMessageid} />
                <PageVisibility>
                    {
                        isVisible =>  
                         <CameraGo
                                cameraControlRef={cameraControlRef}
                                move={move}
                                target={target}
                                ManualDrive={ManualDrive}
                                throttle={throttle}
                                joyMove={joyMove}
                        />
                    }
                </PageVisibility>
                <BoxManager
                        data={data}
                        setData={setData}
                        filter={filter}
                        cameraControlRef={cameraControlRef}
                        move={move}
                        setMove={setMove}
                        setTarget={setTarget}
                        finder_id={FilteredMessageid}
                        setFooter={setFooter}
                        setHello={setHello}
                        setAbout={setAbout}
                        userInfo={userInfo}
                        setUserInfo={setUserInfo}
                        setActionsBack={setActionsBack}
                        actionsBack={actionsBack}
          

                        my={my}
                    />
                    { false ?
                        <Counter />
                        :
                        null
                        }
                    {SStats ? 
                    <Stats />
                    :
                    null    
                    }
                     {
                    inclination > 0.25 &&  inclination < .75 ?    
                        <Sky inclination={inclination} azimuth={azimuth} />
                        :
                        null
                }
                    <Stars radius={100} depth={50} count={5000} factor={4} saturation={0} fade speed={1} />
                  
                </Canvas>
               
            </div>
 
            </div>
    )

}


export default Body
